// extracted by mini-css-extract-plugin
export default {"wrapper":"ControlPanel_wrapper__13fJu"};